export const prefix = 'MERCHANT/SERVICE/WAITER/SETTINGS';

export const GET_EXTRA_CHARGES = `${prefix}/GET_EXTRA_CHARGES`;
export const GET_TAX_CHARGES = `${prefix}/GET_TAX_CHARGES`;
export const GET_VAT = `${prefix}/GET_VAT`;
export const UPDATE_VAT = `${prefix}/UPDATE_VAT`;
export const CREATE_VAT = `${prefix}/CREATE_VAT`;
export const GET_DISCOUNTS = `${prefix}/GET_DISCOUNTS`;
export const UPDATE_EXTRA_CHARGES = `${prefix}/UPDATE_EXTRA_CHARGES`;
export const DELETE_EXTRA_CHARGES = `${prefix}/DELETE_EXTRA_CHARGES`;
export const CREATE_DISCOUNT = `${prefix}/CREATE_DISCOUNT`;
export const UPDATE_DISCOUNT = `${prefix}/UPDATE_DISCOUNT`;
export const REMOVE_DISCOUNT = `${prefix}/REMOVE_DISCOUNT`;

export const CHARGE_TYPE_OPTS = [
  {
    label: 'Fixed Rate',
    value: 'FIXED_RATE',
  },
  {
    label: 'Percentage',
    value: 'PERCENTAGE',
  },
];
